import { createStore } from 'vuex'
import mask from "./mask"

export default createStore({
  modules: {
    mask
  }
})
